import React from "react";
import DesignSitesList from "./design_sites";

// Container for Designing — My Sites: the sites the user created, or is the
// report maker or validator of. Permission-gated by DesignSite.view_my in the
// router.
const MyDesignSitesPage: React.FC = () => {
  return <DesignSitesList scope="my" title="Designing — My Sites" />;
};

export default MyDesignSitesPage;
